import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

import ConfirmationDialog from "Components/Common/ConfirmationDialog";
import { usePutDemandEstimationDocumentApproveMutation } from "apis/DemandEstimation";

const DemandEstimationApprovalButtons = ({
  DemandEstimationData: { applicationId },
  handleClose,
  t,
}) => {
  const [isApproveButtonClicked, setIsApproveButtonClicked] = useState(false);

  const [approveDemandEstimation, { isLoading: isDemandEstimationApproving }] =
    usePutDemandEstimationDocumentApproveMutation();

  const submitHandlerForApproval = async () => {
    try {
      const formData = new FormData();
      formData.append("applicationIds[0]", applicationId);
      formData.append("isApproved", true);

      await approveDemandEstimation(formData);
      setIsApproveButtonClicked(false);
      handleClose();
    } catch (err) {}
  };

  return (
    <>
      {isApproveButtonClicked && (
        <ConfirmationDialog
          message="Are you sure you want to approve demand estimation?"
          onCancel={() => {
            setIsApproveButtonClicked(false);
          }}
          onConfirm={submitHandlerForApproval}
          isOpen={isApproveButtonClicked}
          title="Warning"
          variant="warning"
          isLoading={isDemandEstimationApproving}
        />
      )}

      <div className="text-end">
        <Button
          variant="contained"
          className="mt-2 "
          color="success"
          onClick={() => {
            setIsApproveButtonClicked(true);
          }}
        >
          {t("Approve")}
        </Button>
      </div>
    </>
  );
};

DemandEstimationApprovalButtons.propTypes = {
  DemandEstimationData: PropTypes.object,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};
export default withTranslation()(DemandEstimationApprovalButtons);
